const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/spotdeal/privacy-policy",
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: "/spotdeal/terms",
    exact: true,
    component: "TermsConditions",
  },
];

export default routes;
